// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__329WI","inner":"Footer_inner__244SC","nextIcon":"Footer_nextIcon__KEHEb","innerLeft":"Footer_innerLeft__3QDH5"};